module.exports = __webpack_public_path__ + "img/in-use-gina-papalia@2x.c6b9e736.jpg";